import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { Paginated, PaginationQuery } from "../../types";
import useApi, { buildUrl } from "../api";
import { CustomError } from "../errors";
import { UpsertUser, User } from "./type";

const useUserApi = () => {
  const baseurl = "/users";

  const api = useApi();

  const useUsers = useCallback(
    (query: PaginationQuery) => {
      const url = buildUrl(baseurl, query);
      const result = useQuery<Paginated<User>, CustomError>({
        queryKey: [url],
        queryFn: ({ signal }) => api.get<Paginated<User>>({ url, signal }),
      });
      return { ...result, error: result.error ?? undefined };
    },
    [api],
  );

  const searchNewUsers = useCallback(
    async (query: PaginationQuery, signal?: AbortSignal) => {
      const url = buildUrl(baseurl + "/new", query);
      const data = await api.get<Paginated<User>>({ url, signal });
      return data.items;
    },
    [api],
  );

  // const searchUsers = useCallback(
  //   async (query: PaginationQuery, signal?: AbortSignal, options?: { role: string }) => {
  //     const url = buildUrl(baseurl, query);
  //     const url2 = url.includes("?") ? url + "&role=" + options?.role : url + "?role=" + options?.role;
  //     const data = await api.get<Paginated<User>>({ url: url2, signal });
  //     return data.items;
  //   },
  //   [api],
  // );

  const createUser = useCallback(
    async (pr: UpsertUser) => {
      const data = await api.post<UpsertUser, User>(baseurl, pr);
      api.mutateCache([baseurl]);
      return data;
    },
    [api],
  );

  const updateUser = useCallback(
    async (pr: UpsertUser) => {
      const data = await api.put<UpsertUser>(baseurl, pr);
      api.mutateCache([baseurl]);
      return data;
    },
    [api],
  );

  const useUserProfilePicture = useCallback(
    (userID: string) => {
      const url = `${baseurl}/${userID}/picture`;
      const result = useQuery<string | null, CustomError>({
        queryKey: [url],
        queryFn: ({ signal }) => api.get<string>({ url, signal }),
      });
      return { ...result, error: result.error ?? undefined };
    },
    [api],
  );

  return {
    useUsers,
    searchNewUsers,
    // searchUsers,
    createUser,
    updateUser,
    useUserProfilePicture,
  };
};

export default useUserApi;
